import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "..";

const initialState = {
  attendance: {
    showAttendance: false,
    showAttendanceSheet: false,
    showUserCategory: false,
  },
  cab: {
    master: {
      driver: false,
      passenger: false,
      passengerType: false,
      round: false,
      shift: false,
      showMaster: false,
      status: false,
      vehicle: false,
    },
    showCab: false,
    trip: {
      showTrip: false,
      tripLogs: false,
      tripSchedule: false,
    },
  },

  dashboard: {
    showDashboard: false,
    showDashboardTab1: false,
    showDashboardTab2: false,
    showDashboardTab3: false,
  },
  master: {
    assignee: false,
    constructionItem: false,
    materials: false,
    measurement: false,
    productManufacturer: false,
    seating: false,
    showMaster: false,
    unit: false,
    variant: false,
    option: false,
    subCategory: false,
    productGroup: false,
    department: false,
    designation: false,
  },
  products: {
    cleaning: false,
    construction: false,
    digitalProduct: false,
    emergencyMedicalKit: false,
    gardenOrPlants: false,
    officeEquipments: false,
    paidSoftware: false,
    showProduct: false,
    stationery: false,
  },
  profile: {
    showSetting: false,
    showTeamMember: false,
  },
  report: {
    showReport: false,
  },
  service: {
    showService: false,
  },
  vendor: {
    showVendor: false,
  },
  invoices: {
    showInvoice: false,
  },
  construction: {
    showConstruction: false,
    showPurchase: false,
    master: {
      showMaster: false,
      gst: false,
      cMaterialType: false,
      cItems: false,
      cMeasurement: false,
    },
  },
};

const userContentSlice = createSlice({
  name: "userContent",
  initialState,
  reducers: {
    setUserContent: (state, action) => {
      state.attendance = action.payload.attendance;
      state.cab = action.payload.cab;
      // state.trip = action.payload.trip;
      state.dashboard = action.payload.dashboard;
      state.master = action.payload.master;
      state.products = action.payload.products;
      state.profile = action.payload.profile;
      state.report = action.payload.report;
      state.service = action.payload.service;
      state.vendor = action.payload.vendor;
      state.invoices = action.payload.invoices;
      state.construction = action.payload.construction;
    },

    resetUserContent: (state) => {
      state = initialState;
    },
  },
});

export const { setUserContent, resetUserContent } = userContentSlice.actions;

export const userContent = (state: RootState) => state.userContent;


// function hasPermission(obj:any):boolean{
//   if(typeof obj === "boolean") return obj;
//   if(typeof obj != "object" || typeof obj === null) return false;
//   return Object.values(obj)?.some(hasPermission);
// }
// export const isAuthorized = (state: RootState) => hasPermission(state.userContent);

export default userContentSlice.reducer;
